import { defineMessages } from 'react-intl';

const messages = defineMessages({
  socialMediaGroup: '社媒组',
  liveStreamingGroup: '直播组',
});

export default messages;
